import type { ReactNode } from 'react';

export const symbol_mark_email_unread: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h399q12.75 0 21.38 9 8.62 9 7.62 22-1 12-9.34 20.5-8.33 8.5-20.66 8.5H140v520h680v-325q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v325q0 24-18 42t-42 18H140Zm0-580v520-520Zm340 218 137-89q10-7 19.38-3.85Q645.75-611.7 651-604q5 8 4.5 17.5T644-570l-148 97q-7.5 5-15.75 5T464-473L140-681v-59l340 218Zm202-160.12q-32-32.12-32-78T682.12-838q32.12-32 78-32T838-837.88q32 32.12 32 78T837.88-682q-32.12 32-78 32T682-682.12Z"
		/>
	</svg>
);
